import { useState } from "react";
import { ROLE_HELP_SECTIONS } from "../customerRoles";

/**
 * Link + modal summarizing what each customer business role can and cannot do.
 */
export default function CustomerRoleHelp({ linkLabel = "What do these roles mean?" }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button type="button" style={styles.link} onClick={() => setOpen(true)}>
        {linkLabel}
      </button>
      {open ? (
        <div
          className="modal-backdrop"
          style={styles.backdrop}
          onClick={() => setOpen(false)}
          role="presentation"
        >
          <div
            className="modal"
            style={styles.modal}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="customer-role-help-title"
          >
            <div style={styles.header}>
              <h2 id="customer-role-help-title" style={{ margin: 0, fontSize: 18 }}>
                Customer roles
              </h2>
              <button type="button" onClick={() => setOpen(false)} aria-label="Close">
                Close
              </button>
            </div>
            <p style={styles.intro}>
              A user may hold multiple roles. Permissions are the union of all
              assigned roles. Dashboard, Organization Information / Notifications, and
              Account are available to all signed-in customer users.
            </p>
            <div style={styles.list}>
              {ROLE_HELP_SECTIONS.map((section) => (
                <section key={section.id} style={styles.section}>
                  <h3 style={styles.sectionTitle}>{section.title}</h3>
                  <div style={styles.cols}>
                    <div>
                      <div style={styles.colLabel}>Allowed</div>
                      <ul style={styles.ul}>
                        {section.allows.map((t) => (
                          <li key={t}>{t}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <div style={styles.colLabelMuted}>Not included</div>
                      <ul style={styles.ulMuted}>
                        {section.denies.map((t) => (
                          <li key={t}>{t}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </section>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

const styles = {
  link: {
    background: "none",
    border: "none",
    padding: 0,
    color: "#2563eb",
    fontSize: 13,
    cursor: "pointer",
    textDecoration: "underline",
  },
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: 16,
  },
  modal: {
    width: "min(720px, 100%)",
    maxHeight: "85vh",
    overflow: "auto",
    background: "#fff",
    borderRadius: 8,
    padding: 20,
    boxShadow: "0 16px 40px rgba(0,0,0,0.2)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginBottom: 8,
  },
  intro: {
    fontSize: 13,
    color: "#4b5563",
    margin: "0 0 16px",
    lineHeight: 1.45,
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },
  section: {
    border: "1px solid #e5e7eb",
    borderRadius: 6,
    padding: "12px 14px",
  },
  sectionTitle: {
    margin: "0 0 8px",
    fontSize: 15,
  },
  cols: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
  },
  colLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: "#166534",
    textTransform: "uppercase",
    letterSpacing: 0.3,
    marginBottom: 4,
  },
  colLabelMuted: {
    fontSize: 11,
    fontWeight: 700,
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: 0.3,
    marginBottom: 4,
  },
  ul: {
    margin: 0,
    paddingLeft: 18,
    fontSize: 12,
    color: "#111827",
    lineHeight: 1.45,
  },
  ulMuted: {
    margin: 0,
    paddingLeft: 18,
    fontSize: 12,
    color: "#4b5563",
    lineHeight: 1.45,
  },
};
